import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../App.css';
import Main from '../App';
import { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'jspdf-autotable';
import { Skeleton } from 'primereact/skeleton';
import { FilterMatchMode } from 'primereact/api';
import { InputSearch } from './components/TextField';
import moment from 'moment';
    
function NotificationPage(){
    const [search, setSearch] = useState('');
    const [notif, setNotif] = useState([
        {
            'id': 1,
            'title': "Test Drive Title 1",
            'body': "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Molestiae eum enim quibusdam eligendi delectus fuga impedit porro ducimus ex aspernatur et id nobis iste, adipisci nam explicabo laborum facilis ratione!",
            'datetime': '2025-03-12 10:00 AM'
        }
    ]);
    const [filters, setFilters] = useState();

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        
        const _filters = {
            ...filters,
            global: { ...(filters?.global || {}), value },
        };
    
        setFilters(_filters);
        setSearch(value);
    };
    
    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        });
        setSearch("");
    };

    const renderHeader = () => {
        return (
            <>
                <div className="row g-3 mb-3">
                    <div className="col-md-4">
                    {notif.length <= 0 ? (
                        <Skeleton width="100%" height="4rem" borderRadius="10px"/>
                    ):(
                        <InputSearch type='text' iconLeft='bi bi-search' iconRight='bi bi-filter' placeholder='Search' value={search} onChange={onGlobalFilterChange}></InputSearch>
                    )}
                    </div>
                </div>  
            </>
        );
    };

    const header = renderHeader();

    useEffect(() => {
        initFilters();
    }, []);

    return (
        <Main>
            <div className='row my-3'>
                <div className='col-md-6'>
                    <h5 className='fw-semibold'>Notification</h5>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Notification</li>
                        </ol>
                    </nav>
                </div>
                <div className='col-md-5 d-flex justify-content-end'>
                    
                </div>
            </div>

            <div className='row'>
                <div className='col-md-12'>
                    <div className='card'>
                        <div className='card-body'>
                            {header}
                            <div className='row'>
                                <div className='col-md-12'>
                                    {notif.length <= 0 ? (
                                        <Skeleton width="100%" height="20rem" borderRadius="10px"/>
                                    ):(
                                        <DataTable value={notif} paginator showGridlines rows={10} filters={filters} globalFilterFields={['title', 'body']} dataKey="id" emptyMessage="No role found.">
                                            <Column header="No" body={(rowData, { rowIndex }) => rowIndex + 1} />
                                            <Column field="Notification" header="Notification" body={(rowData) => (
                                                <>
                                                    <p className='fw-semibold m-0 p-0'>{rowData.title}</p>
                                                    <p className='text-secondary m-0 p-0'>{rowData.body}</p>
                                                </>
                                            )} />
                                            <Column header="Datetime" body={(rowData) => moment(rowData.datetime).format('DD MMMM YYYY HH:mm A')} />
                                        </DataTable>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Main>
    );
}

export default NotificationPage;